// extracted by mini-css-extract-plugin
export default {"container":"DevContent_container__RvnB8","childrenContainer":"DevContent_childrenContainer__7qMlq"};